import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-validation-note-dialog',
  templateUrl: './validation-note-dialog.component.html',
  styleUrls: ['./validation-note-dialog.component.scss'],
  standalone: false,
})
export class ValidationNoteDialogComponent {
  inputId: string;
  inputText: string;

  constructor(
    public dialogRef: MatDialogRef<ValidationNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { id: string; text: string },
  ) {
    this.inputId = data.id;
    this.inputText = data.text;
  }

  onCloseClick(): void {
    this.dialogRef.close();
  }
}
